/** Dialoogschil in de stijl van de referentie; gebruikt door elk formulier. */
import type { ReactNode } from 'react'

export function Modal({
  title,
  desc,
  width = 460,
  onClose,
  children,
  footer,
}: {
  title: string
  desc?: ReactNode
  width?: number
  onClose: () => void
  children: ReactNode
  footer?: ReactNode
}) {
  // Geen sluiten bij een klik op de achtergrond (27-09-2026). In Chrome ging
  // "Add User" dicht zodra Jordy in Email of Password begon te typen, zonder
  // dat er iets naar de server ging: de enige weg daarheen in de code was een
  // klik met de achtergrond als doel, vermoedelijk van een wachtwoordmanager
  // of autofill. Een half ingevuld formulier hoort niet op zo'n klik te
  // verdwijnen. Sluiten gaat via ✕, Cancel of Close.
  return (
    // 19-10-2026: de klassen zijn alleen haakjes voor mobiel.css (onder 900px
    // schermvullend); de opmaak zelf blijft inline.
    <div
      className="modalsluier"
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,.55)', zIndex: 99998,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
      }}
    >
      <div className="card modalkaart" style={{ width, maxWidth: 'calc(94vw / var(--dz, 1))', maxHeight: 'calc(90vh / var(--dz, 1))', overflowY: 'auto' }}>
        <div className="row" style={{ alignItems: 'flex-start', gap: 12, marginBottom: desc ? 4 : 12 }}>
          <div style={{ flex: 1, fontSize: 17, fontWeight: 600 }}>{title}</div>
          <button type="button" className="btn ghost sm" aria-label="Close" title="Close"
                  onClick={onClose}>✕</button>
        </div>
        {desc ? <div className="mut2" style={{ fontSize: 12, marginBottom: 12 }}>{desc}</div> : null}
        {children}
        <div className="row" style={{ justifyContent: 'flex-end', marginTop: 14 }}>
          {footer ?? <button className="btn ghost sm" type="button" onClick={onClose}>Close</button>}
        </div>
      </div>
    </div>
  )
}

export function Field({
  label,
  hint,
  children,
}: {
  label: string
  hint?: ReactNode
  children: ReactNode
}) {
  return (
    <div className="field">
      <label>{label}</label>
      {children}
      {hint ? <span className="hint">{hint}</span> : null}
    </div>
  )
}
